(function () {
    'use strict';

    angular
        .module('app')
        .controller('adminOptions', adminOptions);

    adminOptions.$inject = ['$location', '$scope', 'adminOptionsFactory', 'loginService'];

    function adminOptions($location, $scope, adminOptionsFactory, loginService) {
        var vm = this;

        vm.adminOptionsLabel = loginService.resourceStrings["ADMIN_OPTIONS"] + " - " + loginService.resourceStrings["UPLOAD"]; // "Admin Options - Upload"
        vm.noRecordsFoundLabel = loginService.resourceStrings["NO_RECORDS_FOUND"]; // "No records found"
        vm.loadingDataLabel = loginService.resourceStrings["LOADING_DATA"]; // "Loading Data"
        vm.uploadFolderLabel = loginService.resourceStrings["UPLOAD_FOLDER"]; // "Upload Folder"
          
        vm.emailAddressesLabel = loginService.resourceStrings["UPLOAD_NOTIFICATION_EMAIL_ADDRESSES"]; // "Notification Email Addresses"
        vm.emailAddressesDetailLabel = loginService.resourceStrings["UPLOAD_NOTIFICATION_EMAIL_ADDRESSES_DETAIL"]; // "(separate email address with a comma)"
        vm.emailSubjectLabel = loginService.resourceStrings["UPLOAD_NOTIFICATION_EMAIL_SUBJECT"]; // "Notification Email Subject"
        vm.emailEnableLabel = loginService.resourceStrings["UPLOAD_NOTIFICATION_ENABLE"]; // "Send notification email after upload"

        vm.uploadFolderPlaceholderLabel = loginService.resourceStrings["UPLOAD_FOLDER_PLACEHOLDER"]; // "\\machinename\c"
        vm.emailAddressesPlaceholderLabel = loginService.resourceStrings["UPLOAD_NOTIFICATION_EMAIL_ADDRESSES_PLACEHOLDER"]; // "ex: email@domain.com"
        vm.emailSubjectPlaceholderLabel = loginService.resourceStrings["UPLOAD_NOTIFICATION_EMAIL_SUBJECT_PLACEHOLDER"]; // "ex: File Upload Notification"

        vm.okLabel = loginService.resourceStrings["OK"]; // "OK"  
        vm.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"


        $scope.showLoadingPanel = true;

        activate();

        function activate() {
            $scope.uploadFolderError = false;
            $scope.uploadFolderOK = false;
            /* Get Options */
            adminOptionsFactory.getAdminOptions().then(function (response) {
                var response = response;
                $scope.uploadFolder = response.data.UploadFolder;
                $scope.uploadEmail = response.data.UploadEmail;
                $scope.uploadNotification = response.data.UploadNotification;
                $scope.uploadSubject = response.data.UploadSubject;
                $scope.showLoadingPanel = false;
            });
        }

        $scope.testUploadFolder = function () {
            var adminOptions = {
                uploadFolder: $scope.uploadFolder,
                uploadEmail: $scope.uploadEmail,
                uploadNotification: $scope.uploadNotification,
                uploadSubject: $scope.uploadSubject
            };
            adminOptionsFactory.testUploadFolder(adminOptions).then(function (response) {
                $scope.uploadFolderError = false;
                $scope.uploadFolderOK = true;
            }, function (err, status) {
                $scope.uploadFolderOK = false;
                $scope.uploadFolderError = true;
                $scope.uploadFolderErrorText = err.data.Message;
            });
        }

        $scope.OnUploadFolderChange = function () {
            $scope.uploadFolderError = false;
            $scope.uploadFolderOK = false;
        }

        $scope.cancelButtonClicked = function () {
            $scope.onCancel();
        }

        $scope.okButtonClicked = function () {
            /* POST Options */

            /* Declarations */
            var adminOptions = {
                uploadFolder: $scope.uploadFolder,
                uploadEmail: $scope.uploadEmail,
                uploadNotification: $scope.uploadNotification,
                uploadSubject : $scope.uploadSubject
            };
            adminOptionsFactory.postAdminOptions(adminOptions).then(function (response) {
               // do something
            });
            // Call the parent
            $scope.onOK();
        }
    }

})();
